enum AdminDialogType {
	HELP = "help",
	RESTART = "restart",
	LICENSE = "license",
	FUNCTIONS = "functions",
	NEWS = "news",
	LOCAL_AUTH = "local_auth",
	PORTAL_AUTH = "portal_auth",
	TSA = "tsa",
	PROXY = "proxy",
	USER = "user",
	USER_SOURCE = "user_source",
	VALIDATE_USER_SOURCE = "validate_user_source",
	DESIGN = "design",
	CONNECTION_CERTIFICATE = "connection_certificate",
	CERTIFICATE = "certificate",
	KEYSTORE = "keystore",
	TRUSTSTORE = "truststore",
	OAUTH_SERVER = "oauth_server",
	OAUTH_PORTAL = "oauth_portal",
	OAUTH_PROVIDER = "oauth_provider"
}

export default AdminDialogType;